var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4172 0.628906H2.06719C1.33519 0.628906 0.742188 1.22191 0.742188 1.95391V23.3049C0.742188 24.0359 1.33519 24.6289 2.06719 24.6289H13.5622V15.3349H10.4342V11.7129H13.5622V9.04191C13.5622 5.94191 15.4552 4.25391 18.2212 4.25391C19.5462 4.25391 20.6842 4.35291 21.0162 4.39691V7.63691L19.0982 7.63791C17.5942 7.63791 17.3032 8.35291 17.3032 9.40091V11.7139H20.8902L20.4232 15.3359H17.3032V24.6289H23.4192C24.1492 24.6289 24.7422 24.0359 24.7422 23.3039V1.95391C24.7422 1.22191 24.1492 0.628906 23.4172 0.628906V0.628906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.942a74d467780e27f66dafa32e26b8af.svg";
export { ForwardRef as ReactComponent };